function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./~/dom-helpers/~/@babel/runtime/helpers/interopRequireDefault.js
// module id = 67
// module chunks = 0